import { GLYCEMIC_LOAD_CATEGORIES } from './constants';

/**
 * Get category based on glycemic load
 * @param {number} gl - Glycemic Load
 * @returns {string} Category name
 */
export const getCategory = (gl) => {
  if (gl <= GLYCEMIC_LOAD_CATEGORIES.VERY_LOW.threshold) {
    return GLYCEMIC_LOAD_CATEGORIES.VERY_LOW.name;
  }
  if (gl <= GLYCEMIC_LOAD_CATEGORIES.LOW.threshold) {
    return GLYCEMIC_LOAD_CATEGORIES.LOW.name;
  }
  if (gl <= GLYCEMIC_LOAD_CATEGORIES.MODERATE.threshold) {
    return GLYCEMIC_LOAD_CATEGORIES.MODERATE.name;
  }
  return GLYCEMIC_LOAD_CATEGORIES.HIGH.name;
};

/**
 * Get category color classes for Tailwind CSS
 * @param {string} category - Category name
 * @returns {string} CSS classes
 */
export const getCategoryColor = (category) => {
  switch (category) {
    case 'très faible': 
      return 'bg-green-100 text-green-800 border-green-200';
    case 'faible': 
      return 'bg-yellow-100 text-yellow-800 border-yellow-200';
    case 'modérée': 
      return 'bg-orange-100 text-orange-800 border-orange-200';
    case 'élevée': 
      return 'bg-red-100 text-red-800 border-red-200';
    default: 
      return 'bg-gray-100 text-gray-800 border-gray-200';
  }
};

/**
 * Get category emoji
 * @param {string} category - Category name
 * @returns {string} Emoji
 */
export const getCategoryEmoji = (category) => {
  switch (category) {
    case 'très faible': 
      return GLYCEMIC_LOAD_CATEGORIES.VERY_LOW.emoji;
    case 'faible': 
      return GLYCEMIC_LOAD_CATEGORIES.LOW.emoji;
    case 'modérée': 
      return GLYCEMIC_LOAD_CATEGORIES.MODERATE.emoji;
    case 'élevée': 
      return GLYCEMIC_LOAD_CATEGORIES.HIGH.emoji;
    default: 
      return '⚪';
  }
};

/**
 * Get all available categories for filter dropdown
 * @returns {Array} Array of category objects
 */
export const getAllCategories = () => {
  return [
    { value: 'toutes', label: 'Toutes les catégories' },
    { 
      value: GLYCEMIC_LOAD_CATEGORIES.VERY_LOW.name, 
      label: `${GLYCEMIC_LOAD_CATEGORIES.VERY_LOW.emoji} Impact très faible` 
    },
    { 
      value: GLYCEMIC_LOAD_CATEGORIES.LOW.name, 
      label: `${GLYCEMIC_LOAD_CATEGORIES.LOW.emoji} Impact faible` 
    },
    { 
      value: GLYCEMIC_LOAD_CATEGORIES.MODERATE.name, 
      label: `${GLYCEMIC_LOAD_CATEGORIES.MODERATE.emoji} Impact modéré` 
    },
    { 
      value: GLYCEMIC_LOAD_CATEGORIES.HIGH.name, 
      label: `${GLYCEMIC_LOAD_CATEGORIES.HIGH.emoji} Impact élevé` 
    }
  ];
};